module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"response_code":"Код ответа","response_text":"Текст ответа"},"en":{"response_code":"Response code","response_text":"Response text"}}')
  delete Component.options._Ctor
}
